export enum PaymentTimeType {
  ONE_TIME = "one-time",
  RECURRING = "recurring",
}

export const PAYMENT_TIME_TYPE_OPTIONS = [
  { id: PaymentTimeType.ONE_TIME, label: "One Time" },
  { id: PaymentTimeType.RECURRING, label: "Recurring" },
];
